export interface IPagination {
  currentPage: number;
  totalItems: number;
  disable: boolean;
}

class SearchPaginationController {
  data: IPagination;
  onChange: () => void;
  onPaginationChange() {
    this.onChange();
  }
}

export const SearchPaginationComponent: angular.IComponentOptions = {
  controller: SearchPaginationController,
  template: require('./search-pagination.html'),
  bindings: {
    data: '<',
    onChange: '&'
  }
};



// WEBPACK FOOTER //
// ./src/components/linkedDocuments/search-pagination.ts